import { isFormValidationError } from '@src/utilities/form';
import { ICommonFormProps } from '../DynamicForm.types';
import { Input } from 'antd';
import { FormLabel } from '@src/components/ui';
import { ETypographyIntents } from '@src/typings';
import { StyledError } from '@src/components/ui/Input/styles';

export function FormTextArea(props: ICommonFormProps) {
    const isRequired =
        typeof props.registerOptions?.required === 'object'
            ? Boolean(props.registerOptions.required.value)
            : Boolean(props.registerOptions?.required);

    const hasError = Boolean(props.errors);
    const errorMessage = hasError
        ? isFormValidationError(props.errors?.type)
            ? props.errors?.message
            : `${props.label} ${props.errors?.type}`
        : undefined;

    return (
        <>
            {props.label && (
                <div className="flex w-full items-center justify-between">
                    <FormLabel label={props.label} required={isRequired} />
                </div>
            )}
            <Input.TextArea
                className={props.className}
                status={hasError ? 'error' : undefined}
                disabled={props.disabled || false}
                placeholder={props.formProps?.placeholder as string}
                rows={6}
                maxLength={props.formProps?.maxLength}
                showCount={props.formProps?.showCount ? true : false}
                data-component-name={props.keyName}
                {...props.field}
            />
            {hasError && (
                <StyledError intent={ETypographyIntents.Badge}>
                    {errorMessage}
                </StyledError>
            )}
        </>
    );
}
